module.exports = __webpack_public_path__ + "static/media/014.5a91eddc.jpg";